(function($) {

  var ajaxurl = theme_info.php_ajaxurl;

  $(document).ready(function() {

    $('.filters').on('click', '.btn-search', function(e) {
      $('.filter-search').toggle();
    });

    var id_accordion = 0;
    $('.accordion-item').each(function(){
      id_accordion++;
      $(this).find('.accordion-header').attr('id', '#heading'+id_accordion);
      $(this).find('.accordion-button').attr('data-bs-target', '#onfaq'+id_accordion);
      $(this).find('.accordion-button').attr('aria-controls', 'onfaq'+id_accordion);
      
      $(this).find('.accordion-collapse').attr('id', 'onfaq'+id_accordion);
      $(this).find('.accordion-collapse').attr('aria-labelledby', 'heading'+id_accordion);
    });

    $('.atuni-block-gmap').click(function(){
      $(this).css({'z-index' : '10', 'position' : 'relative'});
    });

    function prodImageBg() {
      $('.atuni-block-prod-cat .image').each(function(){
        if ($(window).width() < 992) {
          $(this).find('img').show();
          $(this).css('background-image', 'none');
        }
        else {
          var getImg = $(this).find('img');
          var getImgBg = getImg.attr('src');
          getImg.hide();
          $(this).css('background-image', 'url(' + getImgBg + ')');
        }
      });
    }

    function cboxImageBg() {
      $('.atuni-block-contact-box .image figure').each(function(){
        if ($(window).width() < 1200) {
          $(this).find('img').show();
          $(this).css('background-image', 'none');
        }
        else {
          var getImg = $(this).find('img');
          var getImgBg = getImg.attr('src');
          getImg.hide();
          $(this).css('background-image', 'url(' + getImgBg + ')');
        }
      });
    }

    prodImageBg();
    cboxImageBg();

    $(window).resize(function() {
      cboxImageBg();
      prodImageBg();
    });

    if ($('.produkty-filter').length) {

      setFilters();

      function setFilters() {
        var select_urceni = $('#produktyUrceni');
        var select_pokryti_ztraty = $('#produktyZtraty');
        //var select_cena = $('#produktyCena');

        select_urceni.find('option').not(':eq(0), :selected').remove();
        select_pokryti_ztraty.find('option').not(':eq(0), :selected').remove();
        //select_cena.find('option').not(':eq(0), :selected').remove();

        for (var i=0;i<filter_urceni.length;i++){
          if (filter_urceni[i] != select_urceni.val()) {
            $('<option/>').val(filter_urceni[i]).html(filter_urceni[i]).appendTo(select_urceni);
          }
        }

        for (var i=0;i<filter_pokryti_ztraty.length;i++){
          if (filter_pokryti_ztraty[i] != select_pokryti_ztraty.val()) {
            $('<option/>').val(filter_pokryti_ztraty[i]).html(filter_pokryti_ztraty[i]).appendTo(select_pokryti_ztraty);
          }
        }

        /*for (var i=0;i<filter_cena.length;i++){
          if (filter_cena[i] != select_cena.val()) {
            $('<option/>').val(filter_cena[i]).html(filter_cena[i]).appendTo(select_cena);
          }
        }*/
      }

      function prduktyFilter(page_number) {

        //var bt_ano_ne = ( $('.filter-btn.bat.is-checked').attr('data-bat') ? $('.filter-btn.bat.is-checked').attr('data-bat') :  '' );
        var nbt_ano_ne = ( $('.filter-btn.nbat.is-checked').attr('data-nbat') ? $('.filter-btn.nbat.is-checked').attr('data-nbat') :  '' );
        var blt_ano_ne = ( $('.filter-btn.blt.is-checked').attr('data-blt') ? $('.filter-btn.blt.is-checked').attr('data-blt') :  '' );
        var produkty_urceni = ( $('#produktyUrceni').val() ? $('#produktyUrceni').val() : '' );
        var produkty_pokryti_ztraty = ( $('#produktyZtraty').val() ? $('#produktyZtraty').val() : '' );
        var produkty_cena = ( $('#produktyCena').val() ? $('#produktyCena').val() : '' );
        var produkty_search = $('input[name="filter-search"').val();

        $.ajax({
          type: 'POST',
          url: ajaxurl,
          dataType : 'json',
          data: {
            action: 'filter_produkty',
            //bt_ano_ne: bt_ano_ne,
            nbt_ano_ne: nbt_ano_ne,
            blt_ano_ne: blt_ano_ne,
            produkty_urceni: produkty_urceni,
            produkty_pokryti_ztraty: produkty_pokryti_ztraty,
            produkty_cena: produkty_cena,
            paged_nuber: page_number,
            produkty_search: produkty_search
          },
          beforeSend: function() {
            $('.ajax-loader').css('display', 'flex');
           },
          success: function(res) {
            $('#ajax-list').html(res.content);
            initProduktSlider();
            $('.ajax-loader').css('display', 'none');
            
            $("html").css('scroll-behavior', 'auto');
            $('html, body').animate({ scrollTop: 0 }, 200);
          }
        });
      }

      $('.filter-btn').click(function(e){
        e.preventDefault();
        
        $(this).parent().find('.filter-btn').not(this).removeClass('is-checked');

        $(this).toggleClass('is-checked');
        prduktyFilter();
      });

      $('#produktyUrceni').change(function(){
        prduktyFilter();
      }); 

      $('#produktyZtraty').change(function(){
        prduktyFilter();
      });

      $('#produktyCena').change(function(){
        prduktyFilter();
      }); 

      $('#produktySearchBtn').click(function(e){
        e.preventDefault();
        prduktyFilter();
      });

      $('#produktySearch').on('keypress',function(e) {
        if(e.which == 13) {
          prduktyFilter();
        }
      });

      $('div').on('click', '.produkty-page--numbers', function(e) {
        e.preventDefault();
        var page_number = $(this).attr('data-page');
        prduktyFilter(page_number);
      }); 
    }
    
  });

})( jQuery );

let mybutton = document.getElementById("btn-back-to-top");

window.onscroll = function () {
  scrollFunction();
};

function scrollFunction() {
  if (
    document.body.scrollTop > 20 ||
    document.documentElement.scrollTop > 20
  ) {
    mybutton.style.display = "block";
  } else {
    mybutton.style.display = "none";
  }
}

mybutton.addEventListener("click", backToTop);

function backToTop() {
  document.documentElement.style.scrollBehavior = "smooth";
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}

var mbNavacc = document.getElementsByClassName('menu-item-has-children');
var mbNavTG = document.getElementsByClassName('dropdown-toggler-icon');

function hasClass(elem, className) {
  return new RegExp(' ' + className + ' ').test(' ' + elem.className + ' ');
}

for (i = 0; i < mbNavTG.length; i++) {
  mbNavTG[i].addEventListener('click', toggleItem, false);
}

function toggleItem() {
  var inParent = this.parentNode;
  
  if ( hasClass(inParent, 'children-open')  ) {
    inParent.classList.remove('children-open');
  }
  else{
    inParent.classList.add('children-open');
  }
}

// Slider reference
var referenceSlider = document.getElementsByClassName('ref-splide');

if (referenceSlider.length > 0) {
    document.addEventListener( 'DOMContentLoaded', function() {

    for ( var i = 0; i < referenceSlider.length; i++ ) {
      new Splide( referenceSlider[ i ], {
        arrows: false,
        perPage: 2,
        perMove: 1,
        pagination : true,
        mediaQuery: 'max',
        breakpoints: {
          991: {
            perPage: 1,
          },
        }
      } ).mount();
    }
    
  });
}

// Produkty image slider
function initProduktSlider() {

  var refImgSlider = document.getElementsByClassName('produkty-img-slider');

  if (refImgSlider.length > 0) {

    for ( var i = 0; i < refImgSlider.length; i++ ) {
      new Splide( refImgSlider[ i ], {
        arrows: false,
        pagination : true,
      } ).mount();
    }
  }
}

var refImgSlider = document.getElementsByClassName('produkty-img-slider');

if (refImgSlider.length > 0) {
    document.addEventListener( 'DOMContentLoaded', function() {

    for ( var i = 0; i < refImgSlider.length; i++ ) {
      new Splide( refImgSlider[ i ], {
        arrows: false,
        pagination : true,
      } ).mount();
    }
  
  });
}

// Provedeni image slider
var prvdImgSlider = document.getElementsByClassName('provedení-img-slider');

if (prvdImgSlider.length > 0) {
    document.addEventListener( 'DOMContentLoaded', function() {

    for ( var i = 0; i < prvdImgSlider.length; i++ ) {
      new Splide( prvdImgSlider[ i ], {
        arrows: false,
        pagination : true,
      } ).mount();
    }
  
  });
}
// Daruj dobry sluch gallery slider
document.addEventListener( 'DOMContentLoaded', function () {

  let wpgs = document.getElementById("dds-slider");
  let wpgst = document.getElementById("dds-thumbnail-slider");

  if ( wpgs ) {
    var wpgsmain = new Splide( wpgs, {
      type      : 'fade',
      rewind    : true,
      pagination: false,
      arrows    : false,
    } );
  }

  if ( wpgst ) {
    var wpgsthumbnails = new Splide( wpgst, {
      fixedWidth  : 212,
      fixedHeight : 120,
      gap         : 10,
      rewind      : true,
      pagination  : false,
      cover       : true,
      isNavigation: true,
      breakpoints : {
        600: {
          fixedWidth  : 106,
          fixedHeight : 60,
        },
      },
    } );
  }

  if ( wpgs && wpgst ) {
    wpgsmain.sync( wpgsthumbnails );
  }

  if ( wpgs ) {
    wpgsmain.mount();
  }

  if ( wpgst ) {
    wpgsthumbnails.mount();
  }
  
} );

function initMapPraha() {
  var markerIco = theme_info.map_marker_icon;
  const uluru = { lat: 50.05914592315141, lng: 14.430156081698522 };
  const map = new google.maps.Map(document.getElementById("prahaMap"), {
    mapId: "8399b013c64e9c53",
    zoom: 11,
    center: uluru,
    mapTypeControl: false,
  });

  const marker = new google.maps.Marker({
    position: uluru,
    icon: markerIco,
    map,
    title: "Dobrý sluch - Praha",
  });
}

var prahaMap = document.getElementById("prahaMap");

if (prahaMap) {
  initMapPraha();
}

function initMapBrava() {
  var markerIco = theme_info.map_marker_icon;
  const uluru = { lat: 48.14735503462146, lng: 17.110026068455834 };
  const map = new google.maps.Map(document.getElementById("bravMap"), {
    mapId: "8399b013c64e9c53",
    zoom: 11,
    center: uluru,
    mapTypeControl: false,
  });

  const marker = new google.maps.Marker({
    position: uluru,
    icon: markerIco,
    map,
    title: "Dobrý sluch - Bratislava",
    mapTypeControl: false,
  });
}

var bravMap = document.getElementById("bravMap");

if (bravMap) {
  initMapBrava();
}
